const navItemSelector = '.js-dining-restaurants-nav-item';
const hoursTriggerSelector = '.js-dining-restaurants-hours-trigger';

window.addEventListener('load', () => {
  document.querySelectorAll(navItemSelector).forEach((navItem) => {
    navItem.addEventListener('click', () => {
      const { section } = navItem.dataset;
      const target = section ? document.getElementById(section) : null;

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll(hoursTriggerSelector).forEach((trigger) => {
    const list = trigger.nextElementSibling;

    if (!list) {
      return;
    }

    trigger.addEventListener('click', () => {
      const isOpened = trigger.classList.contains('opened');

      const icon = trigger.querySelector('.dining-restaurants__hours-icon');

      trigger.classList.toggle('opened', !isOpened);
      trigger.setAttribute('aria-expanded', String(!isOpened));
      list.classList.toggle('opened', !isOpened);

      if (icon) {
        icon.classList.toggle('opened', !isOpened);
      }
    });
  });
});
